import { usePageTitle } from "./hooks/usePageTitle";

function Privacy() {
  usePageTitle('Privacy')
  return (
    <div
      id="ts-privacy-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-privacy-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Privacy
        </div>
        <div className="w-full text-normal flex flex-col items-start justify-start p-2 space-y-4">
          <span>
            The following pages contain our privacy policy, and the terms of use
            of the TERRASCIENCES website.
          </span>

          <a className="text-light-text-link" href="/privacy/privacy-policy">Privacy Policy</a>
          <a className="text-light-text-link" href="/privacy/terms-of-use">Terms of Use</a>
        </div> 
      </div>
    </div>
  );
}

export default Privacy;
